/**
 * v15
 * Search token generation improvements
 */

import type { Transaction } from 'dexie';
import type { Item } from '../../models';
import { generateSearchTokens } from '../../transformers';

export const schemaV16 = {
    taxes: 'id, name, value, deleted, [id+deleted]',
    paymentMethods:
        'id, name, type, deleted, enabled, [id+deleted], [enabled+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive], nameLower, *searchTokens',
    itemVariants:
        'id, name, sku, barcode, itemPriceType, itemId, deleted, [id+deleted], [itemId+deleted], [sku+deleted], [barcode+deleted]',

    itemVariantCompositions:
        'id, variantId, deleted, [id+deleted], parentVariantId, [parentVariantId+deleted]',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',

    discounts: 'id, hasRules, deleted, *customerGroupIds, [hasRules+deleted]',

    carts: 'id, dateAdded',
    terminals: 'serialNumber',
};

export async function v16Upgrade(transaction: Transaction) {
    return transaction
        .table('items')
        .toCollection()
        .modify((item: Item) => {
            item.searchTokens = generateSearchTokens(item.name);
        });
}
